<template>
    <!--
    Tailwind UI components require Tailwind CSS v1.8 and the @tailwindcss/ui plugin.
    Read the documentation to get started: https://tailwindui.com/documentation
  -->
    <div class="bg-dark-base flex h-full overflow-hidden py-3">
        <!-- Static sidebar for desktop -->
        <div class="flex h-full overflow-y-auto">
            <div class="border-dark-light bg-dark-base h-fullborder-r flex h-full flex-col">
                <!-- Sidebar component, swap this element with another sidebar if you like -->
                <div class="grid h-full content-between">
                    <!-- Navigation -->
                    <nav class="space-y-1">
                        <div
                            class="hover:bg-dark-lighter flex h-18 cursor-pointer items-center transition-all duration-500"
                        >
                            <router-link :to="{ name: 'sessions.index' }" class="m-2 flex-1 text-center">
                                <div
                                    class="flex flex-col items-center p-2 text-xs font-light"
                                    :class="{ 'bg-dark-lighter rounded-lg': currentRouteLayout === 'sessions' }"
                                >
                                    <ListBulletIcon class="h-6 w-6" />
                                    <div>{{ $t('session.title', 2) }}</div>
                                </div>
                            </router-link>
                        </div>

                        <div
                            v-if="$store.state.auth?.user?.profile === 1"
                            class="hover:bg-dark-lighter flex h-18 cursor-pointer items-center transition-all duration-500"
                        >
                            <router-link :to="{ name: 'comparison.index' }" class="m-2 flex-1 text-center">
                                <div
                                    class="flex flex-col items-center p-2 text-xs font-light"
                                    :class="{ 'bg-dark-lighter rounded-lg': currentRouteLayout === 'comparison' }"
                                >
                                    <DocumentDuplicateIcon class="w-6" />
                                    <div>{{ $t('comparison.title') }}</div>
                                </div>
                            </router-link>
                        </div>

                        <div
                            class="hover:bg-dark-lighter flex h-18 cursor-pointer items-center transition-all duration-500"
                        >
                            <router-link :to="{ name: 'horses.index' }" class="m-2 flex-1 text-center">
                                <div
                                    class="flex flex-col items-center p-2 text-xs font-light"
                                    :class="{ 'bg-dark-lighter rounded-lg': currentRouteLayout === 'horses' }"
                                >
                                    <DressageIcon class="-ml-1 w-8" />
                                    <div>{{ $t('horse.title', 2) }}</div>
                                </div>
                            </router-link>
                        </div>

                        <div
                            class="hover:bg-dark-lighter flex h-18 cursor-pointer items-center transition-all duration-500"
                        >
                            <router-link :to="{ name: 'stablehealth.index' }" class="m-2 flex-1 text-center">
                                <div
                                    class="flex flex-col items-center p-2 text-xs font-light"
                                    :class="{ 'bg-dark-lighter rounded-lg': currentRouteLayout === 'stablehealth' }"
                                >
                                    <HeartPulseIcon class="h-6 w-6" />
                                    <div>{{ $t('stablehealth.menu') }}</div>
                                </div>
                            </router-link>
                        </div>

                        <div
                            class="hover:bg-dark-lighter flex h-18 cursor-pointer items-center transition-all duration-500"
                        >
                            <router-link :to="{ name: 'performance.index' }" class="m-2 flex-1 text-center">
                                <div
                                    class="flex flex-col items-center p-2 text-xs font-light"
                                    :class="{ 'bg-dark-lighter rounded-lg': currentRouteLayout === 'performance' }"
                                >
                                    <GaugeIcon class="h-6 w-6" />
                                    <div>{{ $t('performance.menu') }}</div>
                                </div>
                            </router-link>
                        </div>

                        <div
                            class="hover:bg-dark-lighter flex h-18 cursor-pointer items-center transition-all duration-500"
                        >
                            <router-link
                                :to="{ name: 'teams.sessions.index', meta: { layout: 'teams' } }"
                                class="m-2 flex-1 text-center"
                            >
                                <div
                                    class="flex flex-col items-center p-2 text-xs font-light"
                                    :class="{ 'bg-dark-lighter rounded-lg': currentRouteLayout === 'teams' }"
                                >
                                    <UsersIcon class="h-6 w-6" />
                                    <div>{{ $t('team.title', 2) }}</div>
                                </div>
                            </router-link>
                        </div>

                        <div
                            class="hover:bg-dark-lighter flex h-18 cursor-pointer items-center transition-all duration-500"
                        >
                            <router-link :to="{ name: 'sensors.index' }" class="m-2 flex-1 text-center">
                                <div
                                    class="flex flex-col items-center p-2 text-xs font-light"
                                    :class="{ 'bg-dark-lighter rounded-lg': currentRouteLayout === 'sync' }"
                                >
                                    <CloudArrowUpIcon class="h-6 w-6" />
                                    <div>{{ $t('sensor.sync', 2) }}</div>
                                </div>
                            </router-link>
                        </div>

                        <div
                            class="hover:bg-dark-lighter flex h-18 cursor-pointer items-center transition-all duration-500"
                        >
                            <router-link :to="{ name: 'protocols.index' }" class="m-2 flex-1 text-center">
                                <div
                                    class="flex flex-col items-center p-2 text-xs font-light"
                                    :class="{ 'bg-dark-lighter rounded-lg': currentRouteLayout === 'protocols' }"
                                >
                                    <NewspaperIcon class="h-6 w-6" />
                                    <div>{{ $t('protocol.title', 2) }}</div>
                                </div>
                            </router-link>
                        </div>

                        <div
                            v-if="$store.state.auth?.user?.job_name === 'coach'"
                            class="hover:bg-dark-lighter flex h-18 cursor-pointer items-center transition-all duration-500"
                        >
                            <router-link :to="{ name: 'coaching.sessions.index' }" class="m-2 flex-1 text-center">
                                <div
                                    class="flex flex-col items-center p-2 text-xs font-light"
                                    :class="{ 'bg-dark-lighter rounded-lg': currentRouteLayout === 'coaching' }"
                                >
                                    <PresentationChartLineIcon class="h-6 w-6" />
                                    <div>{{ $t('coaching.title') }}</div>
                                </div>
                            </router-link>
                        </div>
                    </nav>

                    <div
                        class="hover:bg-dark-lighter flex h-18 cursor-pointer items-center transition-all duration-500"
                    >
                        <router-link :to="{ name: 'settings.profile' }" class="m-4 flex-1 text-center">
                            <div
                                class="p-2"
                                :class="{ 'bg-dark-lighter rounded-lg': currentRouteLayout === 'settings' }"
                            >
                                <div class="flex items-center justify-center">
                                    <div class="relative flex items-center justify-center">
                                        <img
                                            class="inline-block h-8 w-8 rounded-full"
                                            :src="$store.state.auth.user?.avatar"
                                        />
                                        <Badge
                                            v-if="pendingInvitations > 0"
                                            :text="pendingInvitations"
                                            :color="tailwind.theme.color.brand.red"
                                            class="absolute -top-2 -right-3 h-4"
                                        />
                                    </div>
                                </div>
                            </div>
                        </router-link>
                    </div>
                </div>
            </div>
        </div>

        <div
            v-show="showSecondColumn"
            class="border-dark-light bg-dark-base flex h-full flex-1 flex-col overflow-y-auto border-r lg:w-1/3 lg:flex-initial"
        >
            <div class="h-full px-4">
                <router-view name="secondColumn" />
            </div>
        </div>
        <!-- Main column -->

        <main
            v-show="showThirdColumn"
            class="relative z-0 h-full flex-1 overflow-x-hidden overflow-y-auto px-8 focus:outline-hidden"
            tabindex="0"
        >
            <router-view name="thirdColumn" />
        </main>
    </div>
</template>

<script setup>
import { computed, ref, watch } from 'vue'
import { useRouter } from 'vue-router'
import tailwind from '@/lib/tailwind'
import { useStore } from 'vuex'
import { badgeCount } from '@/lib/invitations'

import {
    ListBulletIcon,
    DocumentDuplicateIcon,
    UsersIcon,
    CloudArrowUpIcon,
    NewspaperIcon,
    PresentationChartLineIcon,
} from '@heroicons/vue/24/solid'
import DressageIcon from '@/components/icons/DressageIcon.vue'
import GaugeIcon from '@/components/icons/GaugeIcon.vue'
import HeartPulseIcon from '@/components/icons/HeartPulseIcon.vue'
import Arrow from '@/components/icons/RightIcon.vue'
import Badge from '@/components/Badge.vue'

const router = useRouter()
const store = useStore()

// S5: pending invitations and requests received (red badge on the profile picture).
const pendingInvitations = computed(() => badgeCount(store.state.auth?.user))
const currentRouteLayout = computed(() => router.currentRoute.value?.meta?.layout)
const showSecondColumn = ref(true)
const showThirdColumn = ref(true)

watch(
    () => router.currentRoute.value?.meta?.hideSecondColumn,
    (hidden) => {
        showSecondColumn.value = hidden ? false : true
        showThirdColumn.value = hidden ? true : true
    },
    { immediate: true }
)
</script>
